<ng-container *transloco="let t; prefix: 'request-sms-access-dialog'">
  <accredible-dialog-template [title]="t('request_sms')" [preventCloseOnCancel]="loading()">
    <form [formGroup]="formGroup" class="request-sms-access-content" id="request-sms-access-form">
      <div class="content-image-wrapper">
        <div class="text-content">
          <div class="font-normal-semibold">
            {{ t('notes') }}
          </div>

          <div class="font-normal-semibold">
            <a accredible-link>{{ t('learn_more') }}</a>
          </div>

          <div class="items">
            <ul class="font-normal-multiline-regular">
              @for (item of [1, 2, 3, 4]; track item) {
                <li>{{ t('list.item' + item) }}</li>
              }
            </ul>
          </div>
        </div>

        <img ngSrc="/assets/images/campaigns/campaigns-sms.svg" alt="" width="108" height="145" />
      </div>

      <div class="checkboxes">
        <accredible-checkbox-input
          dataCy="checkbox-sms-opt-in-consent"
          [formControlRef]="formGroup.controls.consent_sms"
          [label]="t('checkboxes.consent_sms')" />

        <accredible-checkbox-input
          dataCy="checkbox-sms-is-limited"
          [formControlRef]="formGroup.controls.sms_limitation"
          [label]="t('checkboxes.sms_limitation')" />
      </div>

      <div class="actions">
        <button
          accredible-button-flat
          data-cy="btn-sms-dialog-cancel"
          color="natural"
          [disabled]="loading()"
          (click)="close()">
          {{ t('actions.cancel') }}
        </button>
        <button
          accredible-button
          data-cy="btn-sms-dialog-submit"
          [icon]="loading() ? '' : 'external'"
          [isLoading]="loading()"
          [disabled]="formGroup.invalid"
          (click)="submit()">
          {{ t('actions.form_submission') }}
        </button>
      </div>
    </form>
  </accredible-dialog-template>
</ng-container>
